import React, { ReactElement, useState } from 'react';
import StockTransferReportModal from '../../components/modals/StockTransferReportModal';
import { IWorkspaceAction } from '../../@types/workspaceTypes';

enum StockTransferWorkspaceAction {
  GenerateStockTransferReport = 'GENERATE_STOCK_TRANSFER_REPORT',
}

export const workspaceActionsForPermissions: Array<{ actionReference: StockTransferWorkspaceAction }> = [
  {
    actionReference: StockTransferWorkspaceAction.GenerateStockTransferReport,
  },
];

export const useStockTransferWorkspaceActions = (): [
  Array<IWorkspaceAction<StockTransferWorkspaceAction>>,
  ReactElement
] => {
  const [isOpen, setIsOpen] = useState(false);

  return [
    [
      {
        key: 'generateStockTransferReport',
        text: 'Generate Stock Transfer Report',
        onClick: () => setIsOpen(true),
        actionReference: StockTransferWorkspaceAction.GenerateStockTransferReport,
      },
    ],
    <StockTransferReportModal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    />,
  ];
};
